import React, { useEffect } from 'react';
import { SalesPage } from './pages/SalesPage';
import { MessageCircle } from 'lucide-react';

// Componente del Botón de WhatsApp
function WhatsAppFloatingButton() {
  const phoneNumber = "584123555747";
  const message = encodeURIComponent("¡Hola! Tengo una duda sobre el Masterkit IA, ¿me podrías ayudar?");
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
  return <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-[9999] group" data-id="element-0">
      {/* Tooltip (Mensaje que aparece al pasar el mouse) */}
      <span className="absolute right-16 top-1/2 -translate-y-1/2 bg-white text-black text-sm font-bold py-2 px-4 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 shadow-2xl whitespace-nowrap pointer-events-none border border-gray-200" data-id="element-1">
        ¿Dudas? Escríbeme aquí 👋
      </span>

      {/* Círculo con efecto de pulso */}
      <div className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-[#25D366] rounded-full shadow-[0_0_20px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform duration-300" data-id="element-2">
        <div className="absolute inset-0 bg-[#25D366] rounded-full animate-ping opacity-25" data-id="element-3"></div>
        <MessageCircle className="w-7 h-7 md:w-8 md:h-8 text-white relative z-10" data-id="element-4" />
      </div>
    </a>;
}
export function App() {
  useEffect(() => {
    // Facebook Pixel initialization
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript?.parentNode?.insertBefore(script, firstScript);
    f.fbq('init', '951909027159376');
    f.fbq('track', 'PageView');
  }, []);
  return <div className="relative" data-id="element-5">
      <SalesPage data-id="element-6" />
      <WhatsAppFloatingButton data-id="element-7" />
    </div>;
}